module.exports = __webpack_public_path__ + "static/menu_home-5524b496d6b8690065da0bd60d8272d0.png";